<template>
  <CustomerDetailPlaceholderTab title="Pagos" />
</template>

<script>
import CustomerDetailPlaceholderTab from './CustomerDetailPlaceholderTab.vue';

export default {
  name: 'CustomerDetailPaymentsTab',
  components: { CustomerDetailPlaceholderTab },
};
</script>
